import { setAuthToken as setAuthTokenConfig } from './axiosConfig';

// Backward compatibility wrapper
const setAuthToken = (token: any) => {
    setAuthTokenConfig(token);
};

export default setAuthToken;